import React, { useEffect } from 'react';

import { SidePageV2, withForm } from '@gogame/form';

import {
  AdvertisingPopulationSection,
  PopulationCustomizeSection,
} from './AdvertisingPopulation';
import { ConditionsSection } from './Conditions';
import { CreativesPopulationSection } from './CreativesPopulation';
import { ExtraProvider } from './ExtraContext';
import { ExtraMetricsSection } from './ExtraMetrics';
import { GeneralSection } from './General';
import { ModifyActionSection, MODIFY_ACTION } from './ModifyAction';
import { Notifications, NOTIFICATIONS } from './Notifications';
import { Options } from './Options';
import { PeriodsSection } from './Periods';
import { ScheduleSection } from './Schedule';
import { OWNER } from './constants';
import { smartRuleValidationSchema } from './schemas';

const SmartRuleForm = withForm({
  enableReinitialize: true,
  validationSchema: smartRuleValidationSchema,
})(
  ({
    children,
    title,
    subTitle,
    values,
    setFieldValue,
    loading,
    onClose,
    onExited,
    open,
    isEdit,
    entityId,
  }) => {
    const { [NOTIFICATIONS]: notifications, [OWNER]: owner } = values;

    useEffect(() => {
      if (
        owner &&
        !notifications.some(({ userId }) => userId === owner.userId)
      ) {
        setFieldValue(NOTIFICATIONS, [
          ...notifications,
          {
            userId: owner.userId,
            login: owner.login,
            name: owner.name,
            userEmail: owner.email,
          },
        ]);
      }
    }, [owner]);

    return (
      <ExtraProvider>
        <SidePageV2
          onClose={onClose}
          onExited={onExited}
          open={open}
          loading={loading}
          size={'lg'}
        >
          <SidePageV2.Title
            title={title}
            subTitle={subTitle}
            entityId={entityId}
          />
          <SidePageV2.NewBody>
            <GeneralSection isEdit={isEdit} />
            <AdvertisingPopulationSection />
            <CreativesPopulationSection />
            <ConditionsSection />
            <PopulationCustomizeSection />
            <PeriodsSection />
            <ExtraMetricsSection />
            <ModifyActionSection name={MODIFY_ACTION} isEdit={isEdit} />
            <ScheduleSection />
            <Notifications owner={owner} />
            <Options />
          </SidePageV2.NewBody>
          <SidePageV2.Actions>
            <SidePageV2.CloseButton />
            <SidePageV2.SubmitButton />
          </SidePageV2.Actions>
          {children}
        </SidePageV2>
      </ExtraProvider>
    );
  }
);

export default SmartRuleForm;
